import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function getData(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/customer', { params: new_params })
}

export function delPhoto(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.delete(getBaseUrl() + '/customer/deletephoto', { params: new_params })
}

export function changePhoto(data, headers, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/changephoto', data, { headers: headers }, { params: new_params })
}

export function updateData(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/update', data, { params: new_params })
}

export function changeEmail(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/changeemail', data, { params: new_params })
}

export function changePassword(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/changepassword', data, { params: new_params })
}

export function changePhone(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/changephone', data, { params: new_params })
}

export function updatePhone(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/updatephone', data, { params: new_params })
}

export function getDataPoint(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/customerloyaltypoints', { params: new_params })
}

export function getDataAvatar(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/customer/avatar', { params: new_params })
}

export function changePhonev2(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/auth/v2/phone/update', data, { params: new_params })
}
